import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var basicAction = function basicAction(_ref) {
  var _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked;
  var cssModifier = []; // input state modifiers

  if (checked) cssModifier.push('checked');
  if (readOnly) cssModifier.push('readonly');
  if (disabled) cssModifier.push('disabled');
  return cssModifier;
};

var instance = [basicAction];

var pipe = function pipe() {
  return {
    getInstance: function getInstance() {
      return instance;
    },
    add: function add(customModifier) {
      instance.push(customModifier);
    },
    execute: function execute(props) {
      return instance.reduce(function (temp, action) {
        return [].concat(_toConsumableArray(temp), _toConsumableArray(action(props)));
      }, []);
    }
  };
};

export default pipe;
//# sourceMappingURL=converPropsToFormModifiers.js.map
